export default "__VITE_ASSET__v9JU4A3W__"